export default ({ request }) => ({

  // 供应商联系人相关接口
  scmInfoContactsListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoContacts/list',
      method: 'post',
      data
    })
  },
  scmInfoContactsDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfoContacts/detail',
      method: 'post',
      data
    })
  },
  scmInfoContactsAddApi(data) {
    return request({
      url: '/digitalCenter/scmInfoContacts/add',
      method: 'post',
      data
    })
  },
  scmInfoContactsUpdateApi(data) {
    return request({
      url: '/digitalCenter/scmInfoContacts/update',
      method: 'post',
      data
    })
  },
  scmInfoContactsUpdateStatusApi(data) {
    return request({
      url: '/digitalCenter/scmInfoContacts/updateStatus',
      method: 'post',
      data
    })
  },
})
